import Big from 'big.js';
import * as buttons from 'smg/buttons';
import { GetCountryIDFromPhone } from 'smg/countries';
import { CreateFormSubmissionWithReCaptcha } from 'smg/customer-api/formsubmissions';
import * as promos from 'smg/customer-api/promos';
import * as quoterequests from 'smg/customer-api/quoterequests';
import { Session } from 'smg/customer-api/session';
import * as enhancedconversions from 'smg/enhanced-conversions';
import { ShowError } from 'smg/errors';
import { BlockPastDates, ReportValidity } from 'smg/form';
import * as html from 'smg/html';
import { GetReadableSize } from 'smg/lineitemtypesizes';
import * as models from 'smg/customer-api/models';
import * as object from 'smg/object';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import * as uploads from 'smg/uploads';
import { GetFirstAndLast } from 'smg/users';
import { UUID } from 'smg/uuid';
import { AB } from 'smg/growthbook';
import { QuoteReceivedURL } from '../quote-form-success';
import * as pricecatalog from '../pricecatalog';
import visualQuote from 'theme-data/visual-quote.yaml';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

void main();

async function main() {
    const dataLayer = window.dataLayer || [];

    let buttonsTop = false;
    try {
        const gb = await AB();
        buttonsTop = gb.getFeatureValue('quote-buttons-top', false);
    } catch {
        // GrowthBook not configured, use default layout
    }

    const $stepTemplate = document.querySelector(buttonsTop ? '#step-template-buttons-top' : '#step-template') as HTMLTemplateElement;
    document.querySelector('#step-template')?.remove();
    document.querySelector('#step-template-buttons-top')?.remove();

    const $optionTemplate = document.querySelector('#option-template') as HTMLTemplateElement;
    $optionTemplate.remove();

    const $stepOneForm = template.Clone('#step-one-container').firstElementChild as HTMLFormElement;
    const $stepOneEmail = $stepOneForm.querySelector('#step-one-email') as HTMLInputElement;

    const $steps = document.querySelector('#steps') as HTMLElement;

    const $patchSizeTemplate = document.querySelector('#patches-size-form') as HTMLTemplateElement;
    $patchSizeTemplate.remove();

    // Pictures and extras prices are rendered at build time by the visual-quote/tiles
    // shortcode, one element per file or price, keyed the way the steps below build keys.
    const $tiles = document.querySelector('#visual-quote-tiles') as HTMLTemplateElement;
    const tileImages = new Map<string, Element>();
    for (const $image of Array.from($tiles.content.querySelectorAll<HTMLElement>('[data-keys]'))) {
        const keys = JSON.parse($image.dataset.keys ?? '[]') as string[];
        for (const key of keys) {
            tileImages.set(key, $image.firstElementChild as Element);
        }
    }
    const tilePrices = new Map<string, string>();
    for (const $price of Array.from($tiles.content.querySelectorAll<HTMLElement>('[data-key]'))) {
        tilePrices.set($price.dataset.key ?? '', $price.textContent ?? '');
    }

    const $stepNumbers = document.querySelector('#step-numbers') as HTMLElement;
    const $summary = document.querySelector('#summary') as HTMLElement;
    document.querySelector('#visual-form-title-text')?.classList.remove('d-none');

    let currentStep: number = 0;

    const $form = document.querySelector('#contact-form') as HTMLFormElement;

    const showStep = () => {
        const $divs = $steps.children;
        Array.from($divs).forEach($ => $.classList.add('d-none'));
        $divs[currentStep]?.classList.remove('d-none');

        // have to declare these every time because they can change
        const $stepNumberElements = $stepNumbers.querySelectorAll('div');
        const $summaryElements = $summary.querySelectorAll('li');

        const $currentStepNumber = $stepNumberElements[currentStep];
        if (!$currentStepNumber.classList.contains('success')) {
            $currentStepNumber.classList.add('active');
            $currentStepNumber.addEventListener('click', () => {
                currentStep = Array.from($stepNumberElements).indexOf($currentStepNumber);
                showStep();
            });
        }

        const $currentSummary = $summaryElements[currentStep];
        if (!$currentSummary.classList.contains('success')) {
            $currentSummary.classList.add('active');
            $currentSummary.addEventListener('click', () => {
                currentStep = Array.from($summaryElements).indexOf($currentSummary);
                showStep();
            });
        }

        if (currentStep >= $steps.children.length) {
            $form.classList.remove('d-none');
        } else {
            $form.classList.add('d-none');
        }

        window.scrollTo(0, 0);
    };

    const next = () => {
        $stepNumbers.querySelectorAll('div')[currentStep].classList.add('success');
        $summary.querySelectorAll('li')[currentStep].classList.add('success');

        currentStep++;
        showStep();
    };

    const prev = () => {
        currentStep--;
        showStep();
    };

    const $email = $form.querySelector('#last-step-email') as HTMLInputElement;
    const $summaryEmail = document.querySelector('#summary-email') as HTMLElement;

    $stepOneEmail.addEventListener('input', () => {
        $email.value = $stepOneEmail.value;
        if ($summaryEmail.firstElementChild) {
            $summaryEmail.firstElementChild.textContent = $email.value;
        }
    });

    $email.addEventListener('input', () => {
        $stepOneEmail.value = $email.value;
        if ($summaryEmail.firstElementChild) {
            $summaryEmail.firstElementChild.textContent = $email.value;
        }
    });

    const $phone = $form.querySelector('#phone') as HTMLInputElement;
    const p = new phone.Phone($phone);

    const $name = $form.querySelector('#name') as HTMLInputElement;
    const $company = $form.querySelector('#company') as HTMLInputElement;

    const upload = document.getElementById('upload') as HTMLLabelElement;
    const u = new uploads.Uploader(upload);

    const $quantity = $form.querySelector('#quantity') as HTMLInputElement;
    const $minQty = $form.querySelector('#min-qty') as HTMLElement;
    $quantity.addEventListener('input', () => {
        switch (selectedLineItem) {
        case 'Challenge Coins':
            $minQty.textContent = '50';
            break;
        case 'Patches':
            $minQty.textContent = '100';
            break;
        case 'Lapel Pins':
            $minQty.textContent = '100';
            break;
        case 'Belt Buckles':
            $minQty.textContent = '50';
            break;
        case 'Charms':
            $minQty.textContent = '100';
            break;
        case 'Key Chains':
            $minQty.textContent = '100';
            break;
        case 'Lanyards':
            $minQty.textContent = '100';
            break;
        case 'Medals':
            $minQty.textContent = '50';
            break;
        case 'Ornaments':
            $minQty.textContent = '50';
            break;
        }
    });
    const $dateNeeded = $form.querySelector('#date') as HTMLInputElement;
    BlockPastDates($dateNeeded, { earliest: 'tomorrow' });

    const $notes = $form.querySelector('#notes') as HTMLInputElement;
    const $project = $form.querySelector('#project') as HTMLInputElement;
    const $budget = $form.querySelector('#budget') as HTMLInputElement;
    const $promoInput = document.querySelector('#promo') as HTMLInputElement;
    const $promoCodeSuccess = document.querySelector('#promo-code-success') as HTMLElement;
    const $promoCodeTitle = document.querySelector('#promo-code-title') as HTMLElement;
    const $promoCodeDescription = document.querySelector('#promo-code-description') as HTMLElement;
    const promoInput = new promos.Input($promoInput, {
        error: () => {
            $promoCodeSuccess.classList.add('d-none');
        },
        success: p => {
            $promoCodeSuccess.classList.remove('d-none');
            $promoCodeTitle.textContent = p.name;
            $promoCodeDescription.textContent = p.description;
        },
        $email,
    });
    const $sms = $form.querySelector('#sms-opt-in') as HTMLInputElement;

    const submit = document.querySelector('#submit') as HTMLButtonElement;

    let selectedLineItem: string = '';
    let selectedType: string = '';
    let selectedSize: string = '';
    const selectedChildren: models.QuoteRequestCreateChild[] = [];
    const selectedExtras = new Set<string>();
    const namedExtras: Record<string, string> = {};
    let width: number | undefined;
    let height: number | undefined;

    // Picking a product or type rebuilds every step after it, so nothing picked
    // on the old steps may ride along on the request.
    const clearSelections = () => {
        selectedChildren.length = 0;
        selectedExtras.clear();
        for (const key of Object.keys(namedExtras)) {
            delete namedExtras[key];
        }
    };

    $form.querySelectorAll('.prev').forEach($ => $.addEventListener('click', () => prev()));
    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();
        buttons.Start(submit);

        const extras: models.QuoteRequestCreateExtra[] = [];
        for (const e of Array.from(selectedExtras.values())) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: e,
            }));
        }
        for (const k of Object.keys(namedExtras)) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: k,
                value: namedExtras[k],
            }));
        }

        await promoInput.check();

        if (!ReportValidity($form)) {
            buttons.Stop(submit);
            return false;
        }

        let usePatchesSize = false;
        if (width && height && selectedLineItem === 'Patches') {
            usePatchesSize = true;
        }

        // Awaited outside the chain — a PUT-failure throw would otherwise skip
        // the catch below and leave the button spinning.
        let uploadIDs: number[];
        try {
            uploadIDs = await u.getUploadIDs();
        } catch (err) {
            ShowError(err);
            buttons.Stop(submit);
            return;
        }

        void quoterequests.NewQuoteRequest({
            form: 'visual quote',
            company: $company.value,
            email: $email.value,
            name: $name.value,
            phone: await p.format(),
            countryID: await GetCountryIDFromPhone(p),
            children: selectedChildren,
            lineItem: selectedLineItem,
            dateNeeded: String($dateNeeded.value),
            notes: $notes.value,
            project: $project.value,
            quantity: parseInt($quantity.value, 10),
            size: usePatchesSize ? undefined : selectedSize,
            width: usePatchesSize ? width : undefined,
            height: usePatchesSize ? height : undefined,
            type: selectedType,
            uploadIDs,
            extras,
            budget: parseFloat($budget.value) || undefined,
            promo: $promoInput.value,
            sms: $sms.checked,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const { firstName, lastName } = GetFirstAndLast(String($name.value));
            // The event carries the module's gated view so bare names without
            // a complete address never reach Google (#9198 class 3).
            const userData = enhancedconversions.Set({
                email: sess?.user.emailAddress.email || $stepOneEmail.value,
                phone: sess?.user.phoneNumber.phone || await p.format(),
                firstName: sess?.user.firstName || firstName,
                lastName: sess?.user.lastName || lastName,
            });
            dataLayer.push({
                'event': 'hugo-visual-quote-request-form-success',
                'userData': { ...userData },
                'transactionId': quoteRequest.id,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });
            location.href = QuoteReceivedURL(quoteRequest, location.href);
        }).catch(err => {
            if (object.IsObject(err) &&
                object.IsObject(err['response']) &&
                object.IsObject(err['response']['data']) &&
                object.HasKey(err['response']['data'], 'phone')) {
                const phoneObjectEle = $phone;
                phoneObjectEle.setCustomValidity('This phone number is incorrect');
                ReportValidity(phoneObjectEle);
                phoneObjectEle.addEventListener('input', () => {
                    phoneObjectEle.setCustomValidity('');
                });
            } else {
                ShowError(err);
            }
            buttons.Stop(submit);
        });
    });

    interface option {
        name: string; pluralName?: string; key: string; pricing?: string;
    }
    interface makeStepOpts {
        index: number;
        title: string;
        options: (option | string)[];
        $form?: HTMLFormElement;
        name: string;
        checkboxes?: boolean;
        summary?: () => string;
        click: (option?: option, checked?: boolean) => Promise<void> | void;
    }
    const makeStep = (opts: makeStepOpts) => {
        if ($steps.children.length > opts.index) {
            return;
        }

        const $step = template.Clone($stepTemplate).firstElementChild as HTMLElement;  // Already has .firstElementChild
        const $title = $step.querySelector('.title') as HTMLElement;
        $title.textContent = opts.title;

        if (opts.checkboxes && !buttonsTop) {
            const $next = $step.querySelector('.next')?.cloneNode(true) as HTMLElement;
            $next.classList.add('d-none');
            $next.classList.add('float-end');
            $title.before($next);
        }

        if (opts.index) {
            $step.querySelectorAll('.prev.d-none').forEach($ => {
                $.classList.remove('d-none');
                $.addEventListener('click', () => prev());
            });
        }

        if (opts.checkboxes) {
            $step.querySelectorAll('.next.d-none').forEach($ => {
                $.classList.remove('d-none');
                $.addEventListener('click', () => next());
                $.textContent = 'Skip';
            });
        }

        const $options = $step.querySelector('.options') as HTMLElement;

        for (const o of opts.options) {
            if (typeof o === 'string') {
                $options.appendChild(html.FromString(`<h4 class="w-100 mb-2">${o}</h4>`).firstElementChild as HTMLHeadingElement);
                continue;
            }

            const id = UUID();
            const $option = template.Clone($optionTemplate).firstElementChild as HTMLElement;
            const $input = $option.querySelector('input') as HTMLInputElement;
            $input.setAttribute('value', o.pluralName ?? '');
            $input.setAttribute('name', opts.name);
            $input.setAttribute('id', id);

            if (opts.checkboxes) {
                $input.setAttribute('type', 'checkbox');
            }

            const $label = $option.querySelector('label') as HTMLElement;
            $label.setAttribute('for', id);
            ($label.querySelector('p') as HTMLElement).innerText = o.pluralName || o.name;
            const $image = tileImages.get(o.key);
            const $placeholder = $label.querySelector('img');
            if ($image) {
                $placeholder?.replaceWith($image.cloneNode(true));
            } else {
                $placeholder?.remove();
            }
            $options.appendChild($option);

            if (o.pricing) {
                ($label.querySelector('small') as HTMLElement).textContent = o.pricing;
            }

            $input.addEventListener('click', async () => {
                if (!opts.checkboxes) {
                    const $currentSummary = $summary.querySelectorAll('li')[currentStep];
                    $currentSummary.querySelector('small')?.remove();
                    $currentSummary.appendChild(html.FromString(`<small>${html.Escape(o.pluralName || o.name)}</small>`).firstElementChild as HTMLElement);
                    $steps.style.opacity = '.5';
                    $steps.style.pointerEvents = 'none';
                }

                await opts.click(o, $input.checked);

                if (!opts.checkboxes) {
                    $steps.style.opacity = '1';
                    $steps.style.pointerEvents = 'auto';
                }

                const $next = $step.querySelector('.next.d-none');
                $next?.classList.remove('d-none');
                $next?.addEventListener('click', () => next());

                if (!opts.checkboxes) {
                    next();
                } else {
                    $step.querySelectorAll('.next').forEach($btn => $btn.textContent = 'Next');
                }
            });
        }

        if (opts.$form) {
            $options.after(opts.$form);

            // remove the buttons if they were already in the form
            opts.$form.querySelector('.next')?.parentElement?.remove();

            const $next = $step.querySelector('.next');
            $next?.classList.remove('d-none');
            if (buttonsTop) {
                if (opts.$form.querySelector('.buttons-target')) {
                    opts.$form.querySelector('.buttons-target')?.appendChild($next?.parentElement as HTMLElement);
                }
                $next?.addEventListener('click', () => opts.$form?.requestSubmit());
            } else {
                opts.$form.appendChild($next?.parentElement as HTMLElement);
            }
            $step.querySelector('.prev')?.setAttribute('type', 'button');

            opts.$form.noValidate = true;
            let submitting = false;
            opts.$form.addEventListener('submit', async e => {
                e.preventDefault();

                if (submitting || !ReportValidity(opts.$form as HTMLFormElement)) {
                    return;
                }

                submitting = true;
                try {
                    await opts.click();
                } catch (err) {
                    ShowError(err);
                    return;
                } finally {
                    submitting = false;
                }

                if (opts.summary) {
                    const $currSummary = $summary.querySelectorAll('li')[currentStep];
                    $currSummary.querySelector('small')?.remove();
                    $currSummary.appendChild(html.FromString(`<small>${html.Escape(opts.summary())}</small>`).firstElementChild as HTMLElement);
                }

                next();
            });
        }

        $steps.appendChild($step);
    };

    const products: option[] = visualQuote.products.map(p => ({
        pluralName: p.lineItem,
        name: p.name,
        key: `Product/${p.name}`,
    }));

    // coins are already in the front by default
    // so we don't need to check for Signature Coins
    if (location.hostname.includes('signaturepins')) {
        products.sort((a, b) => {
            const isA = a.pluralName === 'Lapel Pins' ? 1 : 0;
            const isB = b.pluralName === 'Lapel Pins' ? 1 : 0;

            return isB - isA;
        });
        $form.classList.add('signature-pins-visual-quote');
    } else if (location.hostname.includes('signaturepatches')) {
        products.sort((a, b) => {
            const isA = a.pluralName === 'Patches' ? 1 : 0;
            const isB = b.pluralName === 'Patches' ? 1 : 0;

            return isB - isA;
        });
        $form.classList.add('signature-patches-visual-quote');
    } else if (location.hostname.includes('signaturelanyards')) {
        products.sort((a, b) => {
            const isA = a.pluralName === 'Lanyards' ? 1 : 0;
            const isB = b.pluralName === 'Lanyards' ? 1 : 0;

            return isB - isA;
        });
        $form.classList.add('signature-lanyards-visual-quote');
    } else {
        $form.classList.add('signature-coins-visual-quote');
    }

    makeStep({
        index: 0,
        title: 'Please Enter Your Email',
        name: '',
        options: [],
        $form: $stepOneForm,
        click: async () => {
            // The generic step handler must await this capture before it
            // advances; a rejected v3 token renders the v2 retry on this step.
            await CreateFormSubmissionWithReCaptcha({
                form: 'email-capture',
                variant: 'visual-quote',
                payload: {
                    email: $stepOneEmail.value,
                    flagIDs: [models.FlagID.FLAG_PRE_FORM_EMAIL],
                },
            }, {
                $reCaptchaPlaceholder: $stepOneForm.querySelector('.contact-recpatcha-parent') as HTMLElement,
                action: 'email_capture',
            });

            const sess = await Session().catch(() => undefined);
            // `|| undefined` because an empty string means "delete" to Set —
            // a session with no phone must not clear a phone the customer
            // already typed elsewhere. The event carries the gated view so
            // bare names never reach Google (#9198 class 3).
            const userData = enhancedconversions.Set({
                email: sess?.user.emailAddress.email || $stepOneEmail.value,
                phone: sess?.user.phoneNumber.phone || undefined,
                firstName: sess?.user.firstName || undefined,
                lastName: sess?.user.lastName || undefined,
            });
            dataLayer.push({
                'event': 'hugo-pre-form-email-submit',
                'userData': { ...userData },
            });
        },
        summary: () => $stepOneEmail.value,
    });
    // Named handler for product selection - extracted so we can call it for auto-selection
    const handleProductClick = (product?: option) => {
        if (!product) {
            throw Error('no product!');
        }
        const wizardProduct = visualQuote.products.find(p => p.name === product.name);
        if (!wizardProduct) {
            throw Error(`no visual-quote data for ${product.name}`);
        }
        const rush = wizardProduct.rush;
        const isRush = (type?: option) => rush !== undefined && type?.name === rush.name;

        selectedLineItem = product.pluralName ?? '';
        dataLayer.push({
            'event': 'quote_product_selected',
            'product': selectedLineItem,
        });
        $quantity.dispatchEvent(new Event('input'));
        clearSelections();

        Array.from($steps.children).slice(2).forEach($ => $.remove());

        // The wizard's child steps for the current type — rebuilt from the catalog on every
        // type transition, since the set (and the Rush finish rename) depends on the type.
        // The catalog's own rows are shared across the page and never mutated.
        let children: models.BuildDataChild[] = [];

        const updateSteps = (type?: option) => {
            Array.from($stepNumbers.querySelectorAll('div')).slice(!type ? 2 : 3).forEach($ => $.remove());
            Array.from($summary.querySelectorAll('li')).slice(!type ? 2 : 3).forEach($ => $.remove());

            const candidates = [...pricecatalog.Children(product.pluralName ?? '')];
            // push "packages" steps to the end
            candidates.sort((a, b) => {
                const isPackagingA = a.name === 'Packaging' ? 1 : 0;
                const isPackagingB = b.name === 'Packaging' ? 1 : 0;

                return isPackagingA - isPackagingB;
            });

            const steps: { name: string }[] = [];

            if (!type) {
                steps.push({
                    name: 'Type',
                });
            }

            if (wizardProduct.shapes) {
                steps.push({
                    name: 'Shape',
                });
            }

            steps.push({
                name: 'Size',
            });

            const kept: models.BuildDataChild[] = [];
            for (let c of candidates) {
                if (!c.options.length) {
                    continue;
                }
                if (!c.quoteForm) {
                    continue;
                }
                if (wizardProduct.children && !wizardProduct.children.includes(c.name)) {
                    continue;
                }

                if (isRush(type)) {
                    switch (c.name) {
                    case 'Plating':
                        // Rush coins price their finish against the Plating child but call it
                        // Finish; a renamed copy keeps the shared catalog row intact.
                        c = new models.BuildDataChild({ ...c, baseName: 'Finish', name: 'Finish', pluralName: 'Finishes' });
                        break;
                    case 'Packaging':
                        continue;
                    }
                }
                kept.push(c);

                steps.push({
                    name: c.name,
                });
            }
            children = kept;

            if (wizardProduct.extras && !isRush(type)) {
                steps.push({
                    name: 'Extras',
                });
            }

            steps.push({
                name: 'Contact Info',
            });

            for (const s of steps) {
                $stepNumbers.appendChild(document.createElement('div'));
                $summary.appendChild(html.FromString(`<li>${html.Escape(s.name)}</li>`).firstElementChild as HTMLElement);
            }
        };

        updateSteps();

        $stepNumbers.classList.remove('d-none');

        const options: option[] = [];
        const types = pricecatalog.Types(product.pluralName ?? '');
        for (const t of types) {
            if (!t.enabled) {
                continue;
            }

            // Singling out a type keys on its base LineItemTypeID, so renaming
            // the row in the IAP never silently changes what the wizard offers.
            if (wizardProduct.onlyTypes && !wizardProduct.onlyTypes.includes(t.id)) {
                continue;
            }
            if (wizardProduct.excludeTypes?.includes(t.id)) {
                continue;
            }
            // A type with nothing to pick on the Size step would strand the visitor there;
            // patches size by the width/height form instead.
            if (!wizardProduct.shapes && !t.sizes.some(s => s.enabled)) {
                continue;
            }

            options.push({
                name: t.name,
                pluralName: t.pluralName,
                key: `${product.name}/Type/${t.baseName}`,
            });
        }
        if (rush) {
            const key = `${product.name}/Type/${rush.name}`;
            options.push({
                name: rush.name,
                key,
                pricing: tilePrices.get(key),
            });
        }

        makeStep({
            index: 2,
            title: `What type of ${product.name.toLowerCase()} would you like?`,
            name: 'type',
            options,
            click: (type?: option) => {
                if (!type) {
                    throw Error('no type!');
                }

                selectedType = type.pluralName || type.name;
                if (rush && isRush(type)) {
                    selectedType = rush.type;
                }
                dataLayer.push({
                    'event': 'quote_type_selected',
                    'product': selectedLineItem,
                    'type': selectedType,
                });

                Array.from($steps.children).slice(3).forEach($ => $.remove());
                clearSelections();

                updateSteps(type);

                let stepIndexOffset = 3;
                let $form: HTMLFormElement | undefined;
                let summary;

                const options: option[] = [];
                if (rush && isRush(type)) {
                    for (const name of rush.sizes) {
                        options.push({
                            name,
                            key: `${product.name}/Size/${name}`,
                        });
                    }
                } else if (wizardProduct.shapes) {
                    makeStep({
                        index: 3,
                        title: 'What kind of shape is your patch?',
                        name: 'shape',
                        options: wizardProduct.shapes.map(shape => ({
                            name: shape.name,
                            key: `${product.name}/Shape/${shape.name}`,
                        })),
                        click: (shape?: option) => {
                            if (!shape) {
                                throw Error('no shape!');
                            }

                            namedExtras['Shape'] = shape.name;
                            dataLayer.push({
                                'event': 'quote_shape_selected',
                                'product': selectedLineItem,
                                'shape': shape.name,
                            });
                        },
                    });

                    $form = template.Clone($patchSizeTemplate).firstElementChild as HTMLFormElement;
                    summary = () => {
                        width = parseFloat(String(document.querySelector<HTMLInputElement>('#width')?.value));
                        height = parseFloat(String(document.querySelector<HTMLInputElement>('#height')?.value));
                        return GetReadableSize(width, height, '');
                    };

                    stepIndexOffset = 4;
                } else {
                    const sizes = pricecatalog.Sizes(product.pluralName ?? '', type.pluralName ?? type.name);
                    for (const s of sizes) {
                        if (!s.enabled) {
                            continue;
                        }

                        options.push({
                            name: s.name,
                            key: `${product.name}/Size/${s.baseName}`,
                        });
                    }
                }
                makeStep({
                    index: stepIndexOffset,
                    title: 'What size are you looking for?',
                    name: 'size',
                    options,
                    $form,
                    summary,
                    click: (size?: option) => {
                        if (size) {
                            selectedSize = size.name;
                        }
                        dataLayer.push({
                            'event': 'quote_size_selected',
                            'product': selectedLineItem,
                            'type': selectedType,
                            'size': size?.name ?? GetReadableSize(
                                parseFloat(document.querySelector<HTMLInputElement>('#width')?.value || '0'),
                                parseFloat(document.querySelector<HTMLInputElement>('#height')?.value || '0'),
                                '',
                            ),
                        });

                        let i = stepIndexOffset + 1;
                        for (const [childIndex, c] of children.entries()) {
                            const options: option[] = [];
                            const childLabel = c.name;

                            if (rush && isRush(type) && childLabel === 'Finish') {
                                for (const finish of rush.finishes) {
                                    options.push({
                                        name: finish.name,
                                        key: `${product.name}/Finish/${finish.name}`,
                                        pricing: finish.note,
                                    });
                                }
                            } else {
                                for (const o of c.options) {
                                    if (!pricecatalog.Enabled(o)) {
                                        continue;
                                    }
                                    if (rush && isRush(type) && childLabel === 'Edge' && !rush.edges.includes(o.name)) {
                                        continue;
                                    }

                                    const newOption: option = {
                                        name: o.name,
                                        pluralName: o.pluralName,
                                        key: `${product.name}/${c.baseName}/${o.baseName}`,
                                    };
                                    const optionPrice = Big(o.price || 0);
                                    if (!optionPrice.eq(0)) {
                                        newOption.pricing = `+$${optionPrice.toFixed(2)} per unit`;
                                    }
                                    options.push(newOption);
                                }
                            }
                            const index = i++;
                            makeStep({
                                index,
                                title: `What ${childLabel.toLowerCase()} are you looking for?`,
                                name: `child.${childLabel}`,
                                options,
                                click: (option?: option) => {
                                    if (!option) {
                                        throw Error('no option!');
                                    }

                                    const child = new models.QuoteRequestCreateChild({
                                        child: c.pluralName,
                                        option: option.pluralName || option.name,
                                    });
                                    selectedChildren[childIndex] = child;
                                    dataLayer.push({
                                        'event': 'quote_option_selected',
                                        'product': selectedLineItem,
                                        'optionCategory': childLabel,
                                        'optionValue': option.pluralName || option.name,
                                    });
                                },
                            });
                        }

                        if (!wizardProduct.extras || isRush(type)) {
                            return;
                        }

                        const options: (option | string)[] = [];
                        for (const group of wizardProduct.extras) {
                            if (group.heading) {
                                options.push(group.heading);
                            }
                            for (const extra of group.items) {
                                const key = `${product.name}/Extra/${extra.name}`;
                                options.push({
                                    name: extra.name,
                                    pluralName: extra.value,
                                    key,
                                    pricing: tilePrices.get(key),
                                });
                            }
                        }

                        makeStep({
                            index: i,
                            title: 'Any upgrades you\'d like to add?',
                            name: 'extras',
                            options,
                            checkboxes: true,
                            click: (extra?: option, checked?: boolean) => {
                                if (!extra) {
                                    throw Error('no extra!');
                                }

                                if (checked) {
                                    selectedExtras.add(extra.pluralName || extra.name);
                                } else {
                                    selectedExtras.delete(extra.pluralName || extra.name);
                                }
                                dataLayer.push({
                                    'event': 'quote_extra_toggled',
                                    'product': selectedLineItem,
                                    'extra': extra.pluralName || extra.name,
                                    'selected': Boolean(checked),
                                });
                            },
                        });
                    },
                });
            },
        });
    };

    makeStep({
        index: 1,
        title: 'What kind of product are you looking for?',
        name: 'lineItem',
        options: products,
        click: handleProductClick,
    });

    // Auto-select the first product (site-specific one after sorting)
    // This pre-loads step 2 but keeps user on step 1
    const $step1 = $steps.children[1] as HTMLElement;
    const $firstInput = $step1.querySelector('input[type="radio"]') as HTMLInputElement;
    if ($firstInput) {
        // Check the radio button visually
        $firstInput.checked = true;

        // Update the summary sidebar to show selected product
        const $currentSummary = $summary.querySelectorAll('li')[1];
        $currentSummary.querySelector('small')?.remove();
        $currentSummary.appendChild(
            html.FromString(`<small>${html.Escape(products[0].pluralName ?? '')}</small>`).firstElementChild as HTMLElement,
        );

        // Call click handler to load step 2 options (without calling next())
        handleProductClick(products[0]);

        // Show the Next button so user can advance without re-clicking the option
        const $next = $step1.querySelector('.next.d-none');
        $next?.classList.remove('d-none');
        $next?.addEventListener('click', () => next());
    }

    showStep();

    document.querySelector('#quote-spinner')?.remove();
    document.querySelector('#quote-parent')?.classList.remove('d-none');

    const getPodiumWidget = () => document.querySelector<HTMLElement>('#podium-website-widget');

    const getPodiumTop = (): number => {
        const iframe = document.querySelector('#podium-website-widget iframe');
        return iframe?.getBoundingClientRect().top ?? Infinity;
    };

    const getVisualQuoteBottom = (): number => {
        const target = document.querySelector('#quote-parent');
        return target?.getBoundingClientRect().bottom ?? 0;
    };

    let ticking = false;
    const updatePodiumOffset = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const podiumTop = getPodiumTop();
                const quoteBottom = getVisualQuoteBottom();

                if (podiumTop < quoteBottom) {
                    getPodiumWidget()?.classList.add('opacity-0', 'pe-none');
                } else {
                    getPodiumWidget()?.classList.remove('opacity-0', 'pe-none');
                }

                ticking = false;
            });

            ticking = true;
        }
    };

    window.addEventListener('resize', updatePodiumOffset);
    window.addEventListener('scroll', updatePodiumOffset);

    const waitForPodiumLoad = () => {
        const iframe = document.querySelector('#podium-website-widget iframe');
        if (iframe) {
            updatePodiumOffset();
        } else {
            requestAnimationFrame(waitForPodiumLoad);
        }
    };

    waitForPodiumLoad();
}
